/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfVenderListedDto } from '../models/Pagination1OfVenderListedDto';
import type { PostVenderRequestAdmin } from '../models/PostVenderRequestAdmin';
import type { PutVenderRequestAdmin } from '../models/PutVenderRequestAdmin';
import type { VenderAdminDto } from '../models/VenderAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VendersService {
    /**
     * **Required Policy:** `ViewVenderDetails`
     * @returns VenderAdminDto OK
     * @throws ApiError
     */
    public static getVenderAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<VenderAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/venders/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageVenders`
     * @returns VenderAdminDto OK
     * @throws ApiError
     */
    public static putVenderAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutVenderRequestAdmin,
    }): CancelablePromise<VenderAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/venders/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteVenders`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteVenderAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/venders/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewVenders`
     * @returns Pagination1OfVenderListedDto OK
     * @throws ApiError
     */
    public static getVendersAdmin({
        id,
        name,
        searchWord,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        name?: string,
        searchWord?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfVenderListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/venders',
            query: {
                'id': id,
                'name': name,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageVenders`
     * @returns VenderAdminDto Created
     * @throws ApiError
     */
    public static postVenderAdmin({
        requestBody,
    }: {
        requestBody?: PostVenderRequestAdmin,
    }): CancelablePromise<VenderAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/venders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
